import React from 'react';


export default function Services() {
  return (
    <section className="services" id="services">
      <div className="services-container">
        <h2 className="services-title">PROFESSIONAL PAINTING & <h2>DESIGN SOLUTIONS</h2></h2>
        <p className="services-subtitle">
         From stunning interior tranformations to durable exterior caotings, we deliver excellence across
         every project with unmatched attention to details
        </p>

        <div className="services-grid">
          {/* Web Development */}
          <div className="service-card">
            <div className="service-img-wrapper">
              <img src="/assets/images/paint 1" alt="Web Development" />
              <span className="badge">✨Premium</span>
            </div>
            <div className="service-content">
              <h3>Interior & Exterior Painting</h3>
              <p>
                Responsive and modern websites built with the latest
                technologies.
              </p>
              <ul className="service-list">
                <li>Interior & exterior finishes like emulsion, satin, weather-proof coats & more</li>
                <li>Decorative walls & luxury textures (metallic, faux marble, stone effects)</li>
                <li>Weather-resistant coatings for lasting durability</li>
              </ul>
            </div>
          </div>

          {/* E-Commerce */}
          <div className="service-card">
            <div className="service-img-wrapper">
              <img src="/assets/images/pop1.webp" alt="E-Commerce" />
              <span className="badge">✨Premium</span>
            </div>
            <div className="service-content">
              <h3>POP & Ceiling Design</h3>
              <p>
                Secure and scalable online stores that grow with your business.
              </p>
              <ul className="service-list">
                <li>Modern Ceilings Design</li>
                <li>Suspended & gypsum ceilings with spotlight options</li>
                <li>Restoration & repair of old POP/ceiling works</li>
              </ul>
            </div>
          </div>

          {/* Mobile Apps */}
          <div className="service-card">
            <div className="service-img-wrapper">
              <img src="/assets/images/cotton2.webp"  alt="Mobile Apps" />
              <span className="badge">✨Premium</span>
            </div>
            <div className="service-content">
              <h3>House Aesthetic</h3>
              <p>
                We create beautiful house setups — from cotton-inspired designs to modern, rustic, and bohemian looks tailored to you.
              </p>
              <ul className="service-list">
                <li>Turning Houses Into Stylish Homes</li>
                <li>Cotton-inspired house setup</li>
                <li>Modern minimalist design ✨</li>
                <li>Designs That Match Your Lifestyle.</li>
              </ul>
            </div>
          </div>

          {/* UI/UX Design */}
          <div className="service-card">
            <div className="service-img-wrapper">
              <img src="/assets/images/wall.jpg"  alt="UI/UX Design" />
              <span className="badge">✨Premium</span>
            </div>
            <div className="service-content">
              <h3>Wall Screeding & finishing</h3>
              <p>
                Beautiful and user-friendly designs that make your brand
                unforgettable.
              </p>
              <ul className="service-list">
                <li>Wireframing & prototyping</li>
                <li>Brand identity design</li>
                <li>Accessibility focus</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
